var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.69678 0.214661C7.18955 -0.0715537 7.81045 -0.0715534 8.30322 0.214661L14.1968 3.58706C14.6894 3.87342 15 4.39309 15 4.96564L15 7.49982L12.8573 7.49982V6.49314L8.57178 8.95327V13.8426L10 13.0255V15.48L8.30322 16.4516C7.8105 16.7378 7.1895 16.7378 6.69678 16.4516L0.803223 13.0792C0.310566 12.7929 0.000128922 12.2732 0 11.7007L0 4.96564C4.60559e-05 4.39309 0.310557 3.87342 0.803223 3.58706L6.69678 0.214661ZM2.14274 11.393L6.42822 13.8426L6.42822 8.95327L2.14274 6.49314L2.14274 11.393ZM3.21452 4.65802L7.5 7.11896L11.7855 4.65802L7.5 2.20848L3.21452 4.65802Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8545 13.8303C10.8087 13.7772 10.8421 13.6882 10.9078 13.6882H12.2835C12.3245 13.6882 12.3578 13.6507 12.3578 13.6045V9.2501C12.3578 9.20385 12.3911 9.16636 12.4321 9.16636H14.2346C14.2756 9.16636 14.3089 9.20385 14.3089 9.2501V13.6045C14.3089 13.6507 14.3422 13.6882 14.3832 13.6882H15.7589C15.8246 13.6882 15.858 13.7772 15.8122 13.8303L13.3866 16.641C13.3574 16.6748 13.3092 16.6748 13.28 16.641L10.8545 13.8303Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8545 13.8303C10.8087 13.7772 10.8421 13.6882 10.9078 13.6882H12.2835C12.3245 13.6882 12.3578 13.6507 12.3578 13.6045V9.2501C12.3578 9.20385 12.3911 9.16636 12.4321 9.16636H14.2346C14.2756 9.16636 14.3089 9.20385 14.3089 9.2501V13.6045C14.3089 13.6507 14.3422 13.6882 14.3832 13.6882H15.7589C15.8246 13.6882 15.858 13.7772 15.8122 13.8303L13.3866 16.641C13.3574 16.6748 13.3092 16.6748 13.28 16.641L10.8545 13.8303Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadLog);
export default __webpack_public_path__ + "static/media/DownloadLog.b737b9324d40b8b7c692c1324559de05.svg";
export { ForwardRef as ReactComponent };